import { SearchFiltersDropdown } from '../../components/search-filters-dropdown/search-filters-dropdown'
import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { withFilterContext } from '../hocs/filter.context.hoc'

export const InsuranceGroup = withFacetContext(
    FacetName.insurance_group,
    withFilterContext(FilterName.insurance_group, SearchFiltersDropdown, {
        title: 'Insurance group',
        hideLabel: true,
    })
)
